(() => {
  const update = (root, variantId) => {
    if (!root) return;
    const facts = root.querySelector('[data-amchem-christmas-facts]');
    if (!facts) return;
    const form = root.querySelector('[data-product-form]');
    const nativeVariantId = form?.querySelector('[name="id"]')?.value || '';
    const selection = form?.querySelector('variant-selection')?.getAttribute('variant');
    const optionData = facts.querySelector('[data-amchem-fact-options]');
    const options = optionData ? JSON.parse(optionData.textContent) : {};
    const controls = [...(form?.querySelectorAll('[data-variant-option-index]') || [])];
    const chosen = new Map();
    controls.forEach((control) => {
      const index = Number(control.dataset.variantOptionIndex);
      let value;
      if (control.matches('select')) value = control.value;
      else if (control.matches('input[type="radio"]')) {
        if (control.checked) value = control.value;
      } else value = control.querySelector('select')?.value ?? control.querySelector('input[type="radio"]:checked')?.value;
      if (value !== undefined) chosen.set(index, value);
    });
    const complete = (id) => {
      if (!id || selection === 'not-selected' || selection === 'unavailable') return false;
      if (!optionData) return true;
      if (!Object.hasOwn(options, id)) return false;
      return !controls.length || !Array.isArray(options[id]) || options[id].every((value, index) => chosen.get(index) === value);
    };
    let resolvedVariantId = variantId || nativeVariantId || facts.dataset.amchemSingleVariant || '';
    if (!complete(resolvedVariantId) && complete(nativeVariantId)) resolvedVariantId = nativeVariantId;
    if (!complete(resolvedVariantId)) resolvedVariantId = '';
    let selected = null;
    facts.querySelectorAll('[data-amchem-fact-variant]').forEach((fact) => {
      fact.hidden = String(fact.dataset.amchemFactVariant) !== String(resolvedVariantId);
      if (!fact.hidden) selected = fact;
    });
    const prompt = facts.querySelector('[data-amchem-fact-prompt]');
    const hasSelectedVariant = Boolean(resolvedVariantId && resolvedVariantId !== 'not-selected');
    facts.hidden = hasSelectedVariant && !selected;
    if (prompt) prompt.hidden = hasSelectedVariant;
    root.querySelectorAll('[data-product-form] .quantity-selector__label').forEach((label) => {
      if (!label.dataset.amchemOriginalLabel) label.dataset.amchemOriginalLabel = label.textContent.trim();
      label.textContent = selected?.dataset.amchemQuantityLabel || label.dataset.amchemOriginalLabel;
      const input = label.closest('quantity-selector')?.querySelector('[data-quantity-input]');
      if (input) input.setAttribute('aria-label', label.textContent);
    });
  };
  const initialize = (scope) => {
    scope.querySelectorAll('[data-amchem-christmas-product]').forEach((root) => {
      const selected = root.querySelector('[data-amchem-fact-variant]:not([hidden])');
      const nativeVariantId = root.querySelector('[data-product-form] [name="id"]')?.value;
      update(root, nativeVariantId || selected?.dataset.amchemFactVariant);
    });
  };
  document.addEventListener('variant-change', (event) => {
    const root = event.target.closest?.('[data-amchem-christmas-product]');
    update(root, event.detail?.variant?.id || event.detail?.state || root?.querySelector('[data-product-form] [name="id"]')?.value);
  }, true);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  else initialize(document);
})();
